module.exports = __webpack_public_path__ + "static/media/bot-builder.2514e15c.mov";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/bot-builder.mov
// module id = 403
// module chunks = 0